import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';
import { submitFilterDTO } from 'src/components/Common/UI/DndTable/types';


const convertToDataTable = (data: IGetPhonecentersSysModel[]): Array<object> => {
  const dataTableData: Array<object> = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllPhonecentersSysModels = async ( {data} : {data: submitFilterDTO | {}}): Promise<Array<object>> => {
  const response =  await axiosDefaultApi.post(`/api/Entities/GetData/Phonecenters_Sys_Models`, data);
  return convertToDataTable(response as unknown as IGetPhonecentersSysModel[]);
};

type QueryFnType = typeof getAllPhonecentersSysModels;

type UseGetAllPhonecentersSysModelsOptions = {
  data: submitFilterDTO | {};
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllPhonecentersSysModels = ({ data, config }: UseGetAllPhonecentersSysModelsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllPhonecentersSysModels'],
    queryFn: () => getAllPhonecentersSysModels({data}),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};